import React, { FunctionComponent, useMemo } from "react";
import { HorizontalMainNavMenu, HorizontalMainNavMenuItem, HorizontalMainNavMenuProps } from "../nav-menu";
import { GlobalHeaderMobileNavMenu, GlobalHeaderMobileNavMenuProps } from "./global-header-mobile-nav-menu";

export type GlobalHeaderNavMenuProps = Pick<HorizontalMainNavMenuProps, "variant" | "color" | "openSubMenuOnHover"> &
  GlobalHeaderMobileNavMenuProps & {
    isDesktop: boolean;
  };

export const GlobalHeaderNavMenu: FunctionComponent<GlobalHeaderNavMenuProps> = ({
  variant,
  color,
  menuItems,
  openSubMenuOnHover,
  onMenuItemActivate,
  links,
  iconLinks,
  ctaButtons = [],
  isUserSignedIn,
  isDesktop,
}) => {
  const desktopNavMenu = useMemo(() => {
    if (!isDesktop || menuItems.length === 0) {
      return null;
    }

    return (
      <HorizontalMainNavMenu
        label="Primary Navigation Menu"
        variant={variant}
        color={color}
        openSubMenuOnHover={openSubMenuOnHover}
        className="flex-1 ml-3"
      >
        {menuItems.map(
          ({
            id,
            label,
            active,
            className,
            disabled,
            href,
            onClick,
            navMenuItemComponent,
            navMenuItemComponentProps,
            subMenuItems,
            ...restProps
          }) => (
            <HorizontalMainNavMenuItem
              key={id}
              id={id}
              defaultActive={
                subMenuItems?.length > 0
                  ? subMenuItems.reduce(
                      (subMenuItemActive, subMenuItem) => subMenuItemActive || subMenuItem.active,
                      false
                    )
                    ? false
                    : active
                  : active
              }
              className={className}
              disabled={disabled}
              href={href}
              onClick={() => {
                onClick?.();
                onMenuItemActivate(id);
              }}
              navMenuItemComponent={navMenuItemComponent}
              navMenuItemComponentProps={navMenuItemComponentProps}
              {...restProps}
            >
              {[
                label,
                ...(subMenuItems?.length > 0
                  ? subMenuItems.map(
                      ({
                        id,
                        label,
                        active,
                        className,
                        disabled,
                        href,
                        onClick,
                        navMenuItemComponent,
                        navMenuItemComponentProps,
                        ...restProps
                      }) => (
                        <HorizontalMainNavMenuItem
                          key={id}
                          id={id}
                          defaultActive={active}
                          className={className}
                          disabled={disabled}
                          href={href}
                          onClick={() => {
                            onClick?.();
                            onMenuItemActivate(id);
                          }}
                          navMenuItemComponent={navMenuItemComponent}
                          navMenuItemComponentProps={navMenuItemComponentProps}
                          {...restProps}
                        >
                          {label}
                        </HorizontalMainNavMenuItem>
                      )
                    )
                  : []),
              ]}
            </HorizontalMainNavMenuItem>
          )
        )}
      </HorizontalMainNavMenu>
    );
  }, [color, isDesktop, menuItems, onMenuItemActivate, openSubMenuOnHover, variant]);

  if (isDesktop) {
    return desktopNavMenu;
  } else {
    return (
      <GlobalHeaderMobileNavMenu
        variant={variant}
        color={color}
        menuItems={menuItems}
        onMenuItemActivate={onMenuItemActivate}
        links={links}
        iconLinks={iconLinks}
        ctaButtons={ctaButtons}
        isUserSignedIn={isUserSignedIn}
      />
    );
  }
};
